<template>
  <span data-test-id="MessagesComponent" @click="showModal">
    <b-nav-item data-test-id="messagesIcon" class="message-icon">
      <b-icon icon="envelope" variant="danger"></b-icon>
      <div v-show="unreadBroadcastMessages > 0" class="message-counter">
        {{ unreadBroadcastMessages }}
      </div>
    </b-nav-item>

    <b-modal ref="messages-modal" hide-footer title="Message Center" data-test-id="messageCenterHeader">
      <div class="d-block text-center message-center">
        <h4 v-show="!messages || messages.length === 0" data-test-id="noMessageContent">
          Looks like it's quiet. No broadcast messages at this time.
        </h4>
        <b-list-group v-show="messages && messages.length > 0">
          <b-list-group-item
            v-for="(message, index) in messages"
            :key="index + message.timestamp"
            class="text-left flex-column align-items-start"
          >
            <div v-show="message.timestamp" class="d-flex w-100 justify-content-between">
              <p class="mb-1">&nbsp;</p>
              <small>{{
                new Date(message.timestamp).toLocaleString("en-US", {
                  hour12: true,
                })
              }}</small>
            </div>

            <p
              v-linkified
              class="message-text"
              :class="{ 'message-urgent': message.urgent }"
              v-html="message.content.replace(/\n/g, '<br>').replace('Tap here to go to the case.', '')"
            />

            <p
              v-if="message.type === 'emsDispatch'"
              class="message-text"
              :class="{ 'message-urgent': message.urgent }"
              data-test-id="ift-load-case-link"
            >
              <span>Click </span>
              <a class="ift-case-link" @click="confirmLoadIftCase(message.caseNumber)">
                <i>Here</i>
              </a>
              <span> to load the case.</span>
            </p>

            <small>{{ message.senderOrganizationName }}</small>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-modal>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BIcon } from "bootstrap-vue";
import { LoggerService as lgg } from "vue-components-library";
import { showConfirmDialog } from "@/Utils/Dialogs";

const NO_INTERNET_WHILE_IN_TRANSFER = "Slow or no internet connection. Please check your internet settings.";

export default {
  name: "Messages",
  components: { BIcon },
  data() {
    return {
      isOnline: true,
      sendingRequest: false,
    };
  },
  computed: {
    ...mapGetters("PubNubSubscription", {
      messages: "broadcastMessages",
      unreadBroadcastMessages: "unreadBroadcastMessages",
    }),
    ...mapGetters("TeamSelection", ["selectedTeam"]),
    ...mapGetters("TruckSelection", ["selectedTruck"]),
  },
  methods: {
    ...mapActions("Global", ["checkOnlineStatus"]),
    ...mapActions("PubNubSubscription", ["setLastBroadcastMessageReadAt"]),
    ...mapActions("CaseTransfer", ["request"]),
    showModal() {
      this.setLastBroadcastMessageReadAt();
      this.$refs["messages-modal"].show();
    },
    hideModal() {
      this.$refs["messages-modal"].hide();
    },
    confirmLoadIftCase(caseNumber) {
      showConfirmDialog(this.$bvModal, "StartCase", "Are you sure you want to start this case?", "Start", () =>
        this.loadIftCase(caseNumber),
      );
    },
    async loadIftCase(caseNumber) {
      this.sendingRequest = true;
      const isOnline = await this.checkOnlineStatus();
      if (isOnline) {
        if (caseNumber) {
          try {
            await this.request({
              caseTransferCode: caseNumber,
              payload: {
                emsAgencyId: this.selectedTeam.id,
                truckId: this.selectedTruck.id,
              },
            });
            this.sendingRequest = false;
          } catch (err) {
            window.alert(`Warning: Case ${caseNumber} not available for transfer.`);
            lgg.info("Error", err);
            this.sendingRequest = false;
          }
        }
      } else {
        window.alert("Warning" + NO_INTERNET_WHILE_IN_TRANSFER);
        this.sendingRequest = false;
      }
    },
  },
};
</script>

<style scoped>
.message-center {
  min-height: 400px;
}
.message-icon {
  position: relative;
}
.message-icon a {
  padding: 0 !important;
}
.message-counter {
  position: absolute;
  top: -4px;
  right: -10px;
  color: white;
  background-color: red;
  padding: 4px 3px;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  line-height: 1;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
}
.message-text {
  margin-bottom: 0.25rem !important;
  font-weight: bold;
}
.message-urgent {
  color: red;
}
.ift-case-link {
  color: blue;
  cursor: pointer;
}
</style>
